import { InputField, Form } from "@made-people/blueprint-form";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { useResetPasswordForm } from "../hooks/use-reset-password-form";

type ResetPasswordFormProps = {
  form: ReturnType<typeof useResetPasswordForm>;
  loginAction: React.ReactNode;
};

export const ResetPasswordForm = ({
  form,
  loginAction,
}: ResetPasswordFormProps) => {
  const translate = useTranslate();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2 md:gap-4">
        <h2 className="text-heading-sm">
          {translate("Account_ResetPassword_Heading")}
        </h2>
        <p className="text-body-md">
          {translate("Account_ResetPassword_Lead")}
        </p>
      </div>
      <Form>
        <div className="flex flex-col gap-6">
          <InputField
            template="floating-label"
            type="email"
            label={translate("Form_Field_Email")}
            placeholder={translate("Form_Field_Email")}
            value={form.email}
            onChange={(e) => form.setEmail(e.target.value)}
            onKeyDown={form.handleKeyDown}
            helperText={
              form.error ? { text: form.error, type: "error" } : undefined
            }
          />
          <div className="flex flex-col gap-4">
            <ButtonAsButton
              label={translate("Account_ResetPassword_PrimaryAction")}
              onClick={form.handleSubmit}
              progress={form.loadingState}
              variants={{ width: "full" }}
            />
            {loginAction}
          </div>
        </div>
      </Form>
    </div>
  );
};
